import { node } from 'prop-types';
import React, { createContext } from 'react';
import Cookies from 'js-cookie';

import { errorLogger } from '@ajaibid/utils';
import { REMOTE_CONFIG_THROTTLE_MILLIS } from '@config/constanta';
import { firebaseApp, isMessagingSupported } from './firebaseApp';
import DEFAULT_FLAGS from './constants';

export const FirebaseContext = createContext({});

const FirebaseProvider = ({ children }) => {
  const [flags, setFlags] = React.useState(DEFAULT_FLAGS);

  React.useEffect(() => {
    // Firebase remote config setup
    const remoteConfig = firebaseApp.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = REMOTE_CONFIG_THROTTLE_MILLIS;
    remoteConfig.defaultConfig = DEFAULT_FLAGS;
    remoteConfig
      .fetchAndActivate()
      .then(() => 
        remoteConfig.getAll()
      )
      .then((remoteFlags) => {
        const parsedFlags = {};
        Object.keys(remoteFlags).forEach((key) => {
          try {
            // Try to parse value (for non-string values)
            parsedFlags[key] = JSON.parse(remoteFlags[key]._value);
          } catch (err) {
            // Else return value as it is (for string values)
            parsedFlags[key] = remoteFlags[key]._value;
          }
        });
        setFlags(parsedFlags);
      })
      .catch((err) => {
        errorLogger('FIREBASE_REMOTE_CONFIG', err.message);
      });

    // Firebase messaging setup
    if (isMessagingSupported) {
      const messaging = firebaseApp.messaging();
      Notification.requestPermission()
        .then(async () => {
          const token = await messaging.getToken();
          Cookies.set('notification_token', token);
          return token;
        })
        .catch((err) => {
          errorLogger('FIREBASE_MESSAGING', err.message);
        });
    }
  }, []);

  return <FirebaseContext.Provider value={{ flags }}>{children}</FirebaseContext.Provider>;
};

FirebaseProvider.propTypes = {
  children: node.isRequired,
};

export default FirebaseProvider;
